import React from 'react';
import { connect } from "react-redux";
import {toggleShowAssignQuotePopup} from "../PageLayout/Popups/AssignQuotePopup/assignPopupFunctions";

const JobCopyButton = (props) => {
  const {job, toggleShowAssignQuotePopup} = props;

  const cloneJobClick = () => {
    toggleShowAssignQuotePopup(true, job);
  };

  return (
    <div className="job-board-copy-icon" onClick={cloneJobClick}/>
  )
};

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {
  toggleShowAssignQuotePopup
};

export default connect(mapStateToProps, mapDispatchToProps)(JobCopyButton);
